<script>
import articleTag from './articleTag.vue'
import {languages,publications} from '../utils/articleTags'
export default {
  components: {
    articleTag
  },
  props: {
    pubdate: [String],
    language: [Array],
    pubType: [Array]
  },
  computed: {
    showLanguage() {
      if(!this.language) return;
      return this.language.filter(item => {
        return languages[item];
      }).map(item => {
        return languages[item][0]
      })
    },
    showPubType() {
      if(!this.pubType) return;
      return this.pubType.filter(item => {
        return publications[item];
      }).map(item => {
        return publications[item]
      })
    }
  },
  data() {
    return {

    }
  },
}
</script>

<template>
  <div class="articleTags">
    <articleTag>{{ pubdate }}</articleTag>
    <articleTag icon='language' v-for="(item,index) in showLanguage" :key="item">{{ item }}</articleTag>
    <articleTag icon='pubType' v-for="(item,index) in showPubType" :key="item">{{ item }}</articleTag>
  </div>
</template>


// WEBPACK FOOTER //
// src/components/articleTags.vue